import http from "./httpService";
import { pegawaiApi } from "./config.json";
import auth from "./authService";

export async function getDataForModal(val) {
  const obj = { val };
  const { data } = await http.post(pegawaiApi + "selectModalData.php", obj);
  return data;
}
export async function getData(search, limit, offset, order, type) {
  const obj = { search, order, type, limit, offset };
  const { data } = await http.post(pegawaiApi + "selectData.php", obj);
  return data;
}
export async function getAllData() {
  const { data } = await http.get(pegawaiApi + "selectAllData.php");
  return data;
}
export async function getDataById(id_pegawai) {
  const obj = { id_pegawai };
  const { data } = await http.post(pegawaiApi + "selectoneData.php", obj);
  return data;
}
export async function deleteData(id_pegawai) {
  const obj = { id_pegawai };
  const { data } = await http.post(pegawaiApi + "deleteData.php", obj);
  return data;
}
export async function insertData(detail,department) {
  const username = auth.getCurrentUser();
  const obj = { detail,department, username };
  const { data } = await http.post(pegawaiApi + "insertData.php", obj);
  return data;
}
export async function updateData(detail) {
  const obj = { detail };
  const { data } = await http.post(pegawaiApi + "updateData.php", obj);
  return data;
}
export async function updateAkses(header, detail) {
  const obj = { header, detail };
  const { data } = await http.post(pegawaiApi + "updateAkses.php", obj);
  return data;
}
export async function declineRequest(header, detail) {
  const obj = { header, detail };
  const { data } = await http.post(pegawaiApi + "declineRequest.php", obj);
  return data;
}
export async function requestUpdateAkses(header, detail) {
  const username = auth.getCurrentUser();
  const obj = { header, detail, username };
  const { data } = await http.post(pegawaiApi + "requestUpdateAkses.php", obj);
  return data;
}
export async function getAllAkses() {
  const id_pegawai = auth.getCurrentIdCustomer();
  const token = auth.getAksesToken();
  const username = auth.getCurrentUser();
  const department = 'hr';
  const obj = { id_pegawai, department, token, username };
  const { data } = await http.post(pegawaiApi + "selectAllAkses.php", obj);
  return data;
}
export async function getDataPending(search, limit, offset, order, type) {
  const obj = { search, order, type, limit, offset };
  const { data } = await http.post(pegawaiApi + "selectDataPending.php", obj);
  return data;
}
export async function getDataPendingById(id_pegawai_hak_akses_pending) {
  const obj = { id_pegawai_hak_akses_pending };
  const { data } = await http.post(
    pegawaiApi + "selectoneDataPending.php",
    obj
  );
  return data;
}



// WEBPACK FOOTER //
// ./src/services/pegawaiServices.js